<template>
  <div class="card">
    <div class="card-header shop-list-header">
      <div class="name-search">
        <input type="text" v-model="shopName" class="form-control form-control-sm" placeholder="店舗名で検索" @keyup.enter="searchShop" />
        <button class="btn btn-sm btn-outline-secondary" @click="searchShop">
          <i class="fas fa-search"></i>
        </button>
      </div>
      <div class="header-right">
        <label class="archive-toggle">
          <input type="checkbox" v-model="showArchived" />
          <span>アーカイブ済みを表示</span>
        </label>
        <button class="btn btn-success" @click="this.$router.push({name:'CompanyShopRegisterPage'});">
          <i class="fas fa-plus mr-1"></i>店舗を登録
        </button>
      </div>
    </div>
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-hover shop-table">
          <thead>
            <tr>
              <th>店舗名</th>
              <th>管理者</th>
              <th class="text-center" style="width:80px;">スタッフ数</th>
              <th class="text-center" style="width:100px;">TC調整</th>
              <th style="width:120px;">シフトパターン</th>
              <th class="text-center" style="width:80px;">詳細</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="shop in shops" :key="shop.id" :class="{ 'row-archived': shop.deleted_at }">
              <td class="td-name td-clickable" @click="switchToShop(shop)">
                {{ shop.shop_name }}
                <span v-if="shop.deleted_at" class="badge-archived">アーカイブ済み</span>
              </td>
              <td class="td-managers">
                <div class="managers-list">
                  <span v-for="staff in filteredStaff(shop)" :key="staff.id" class="manager-chip">
                    {{ staff.name }}
                  </span>
                  <span v-if="filteredStaff(shop).length === 0" class="text-muted">未設定</span>
                </div>
              </td>
              <td class="text-center">{{ shop.staff.length }}名</td>
              <td class="text-center">
                <span v-if="shop.time_adjustment > 0" class="badge-on">◯ {{ shop.time_adjustment }}分</span>
                <span v-else class="badge-off">×</span>
              </td>
              <td>
                <span v-if="shop.shift_pattern_type === 2" class="badge-shift">シフト制</span>
                <span v-else class="badge-corporate">企業パターン</span>
              </td>
              <td class="text-center">
                <button class="btn btn-sm btn-outline-primary" @click="viewDetails(shop.id)">
                  <i class="fas fa-arrow-right"></i>
                </button>
              </td>
            </tr>
            <tr v-if="shops.length === 0">
              <td colspan="6" class="text-center text-muted py-4">店舗データがありません</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompanyShopPage',
  data () {
    return {
      shops: [],
      shopName: null,
      showArchived: false,
    }
  },
  computed: {
    filteredStaff() {
      return (shop) => {
        return shop.staff.filter((staff) => staff.pivot.manager_flag);
      };
    },
  },
  mounted() {
    this.getShopList();
  },
  watch: {
    showArchived () {
      this.shopName = null;
      this.getShopList();
    },
  },
  methods: {
    viewDetails (param) {
      this.$router.push({name:'CompanyShopDetailsPage', params: {shop_id: param}});
    },
    switchToShop(shop) {
      const data = {
        data: {
          access: 3,
          company_id: this.$store.getters.company,
          shop_id: shop.id,
          shop_name: shop.shop_name,
          token: this.$store.getters.token,
          userName: this.$store.getters.userName,
          shops: this.shops,
        }
      };
      this.$store.dispatch('setAuth', data).then(() => {
        this.$router.push({ name: 'StoreCalendarPage' });
      });
    },
    getShopList () {
      const company_id = this.$store.getters.company;
      const params = this.showArchived ? { with_trashed: 1 } : {};
      this.$http.get(process.env.VUE_APP_API_PATH + '/company/shopList/'+company_id, { params })
      .then(response => {
        if (response.data.success) {
          this.shops = response.data.data;
        }
      })
      .catch(error => {
        this.shops = [];
        if (error.response) {
          this.$toast.error(error.response.data.message);
        }
      });
    },
    searchShop () {
      const company_id = this.$store.getters.company;
      if (this.shopName) {
        const params = this.showArchived ? { with_trashed: 1 } : {};
        this.$http.get(process.env.VUE_APP_API_PATH + '/company/shopSearch/'+company_id+'/'+this.shopName, { params })
        .then(response => {
          if (response.data.success) {
            this.shops = response.data.data;
          }
        })
        .catch(error => {
          if (error.response) {
            this.$toast.error(error.response.data.message);
          }
        });
      } else {
        this.getShopList();
      }
    },
  },
};
</script>

<style scoped>
.shop-list-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: #f7fafc;
}

.name-search {
  display: flex;
  gap: 4px;
}

.name-search .form-control {
  width: 200px;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.archive-toggle {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: #4a5568;
  cursor: pointer;
  white-space: nowrap;
}

.archive-toggle input {
  width: 15px;
  height: 15px;
  cursor: pointer;
}

.shop-table thead th {
  font-size: 13px;
  font-weight: 700;
  color: #4a5568;
  background: #f7fafc;
  border-bottom: 2px solid #e2e8f0;
  padding: 14px 16px;
  white-space: nowrap;
}

.shop-table tbody td {
  padding: 12px 16px;
  font-size: 15px;
  vertical-align: middle;
  border-color: #edf2f7;
}

.shop-table tbody tr {
  transition: background-color 0.15s ease;
}

.shop-table tbody tr:hover {
  background-color: #f0faf4;
}

.td-name {
  font-weight: 600;
  color: #1a202c;
  white-space: nowrap;
}

.td-managers {
  min-width: 160px;
}

.managers-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.manager-chip {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  background: #f0fff4;
  border: 1px solid #c6f6d5;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #22543d;
}

.td-clickable {
  cursor: pointer;
  transition: color 0.15s;
}
.td-clickable:hover {
  color: #049C4C !important;
  text-decoration: underline;
}

.badge-on {
  display: inline-block;
  background: #c6f6d5;
  color: #22543d;
  font-size: 12px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 4px;
  white-space: nowrap;
}
.badge-off {
  display: inline-block;
  background: #e2e8f0;
  color: #a0aec0;
  font-size: 12px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 4px;
}
.badge-corporate {
  display: inline-block;
  background: #edf2f7;
  color: #4a5568;
  font-size: 11px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 4px;
  white-space: nowrap;
}
.badge-shift {
  display: inline-block;
  background: #bee3f8;
  color: #2a4365;
  font-size: 11px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 4px;
  white-space: nowrap;
}

.badge-archived {
  display: inline-block;
  margin-left: 8px;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 700;
  background: #fed7d7;
  color: #822727;
  vertical-align: middle;
}

.row-archived {
  background-color: #fffafa;
}

.row-archived .td-name {
  color: #a0aec0;
}
</style>
